import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useState } from "react";
import { Box, Flex, Link, LoadingSpinner, Span, StarRating, Text, TextButton } from "@catchoftheday/cg-components";
import { MetaTags } from "@catchoftheday/common-vendors";
import { useTheme } from "@catchoftheday/theme";
import { date as dateUtils } from "@catchoftheday/utilities";
import { avatarColours } from "@product-app/consts";
import { useMarkReviewHelpfulMutation } from "@product-app/generated/graphql";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ReviewItem = function ReviewItem(_ref) {
  var reviewId = _ref.id,
      comment = _ref.comment,
      date = _ref.date,
      helpful = _ref.helpful,
      rating = _ref.rating,
      author = _ref.author,
      customerOwnsReview = _ref.customerOwnsReview;

  var _useState = useState(helpful),
      helpfulReviews = _useState[0],
      setHelpfulReviews = _useState[1];

  var _useState2 = useState(false),
      requiresAuth = _useState2[0],
      setRequiresAuth = _useState2[1];

  var _useMarkReviewHelpful = useMarkReviewHelpfulMutation({
    fetchPolicy: "no-cache"
  }),
      _useMarkReviewHelpful2 = _slicedToArray(_useMarkReviewHelpful, 2),
      updateHelpfulReview = _useMarkReviewHelpful2[0],
      loading = _useMarkReviewHelpful2[1].loading;

  var handleUpdateHelpfulReview = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(helpfulCountAdjustment) {
      var _yield$updateHelpfulR, data, customerHelpfulFeedback;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return updateHelpfulReview({
                variables: {
                  input: {
                    reviewId: reviewId,
                    helpfulCountAdjustment: helpfulCountAdjustment
                  }
                }
              });

            case 2:
              _yield$updateHelpfulR = _context.sent;
              data = _yield$updateHelpfulR.data;

              if ((data === null || data === void 0 ? void 0 : data.markReviewHelpful.__typename) == "UnauthorisedUserError") {
                setRequiresAuth(true);
              } else if ((data === null || data === void 0 ? void 0 : data.markReviewHelpful.__typename) == "ProductReview") {
                customerHelpfulFeedback = data === null || data === void 0 ? void 0 : data.markReviewHelpful.helpful.customerHelpfulFeedback;
                setHelpfulReviews(function (prevState) {
                  if (prevState.customerHelpfulFeedback !== customerHelpfulFeedback) {
                    return _objectSpread(_objectSpread({}, prevState), {}, {
                      customerHelpfulFeedback: customerHelpfulFeedback
                    });
                  }

                  return prevState;
                });
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [updateHelpfulReview, reviewId]);

  var _useTheme = useTheme(),
      backgroundColor = _useTheme.colors.ui.backgroundColor;

  return ___EmotionJSX(Flex, {
    itemType: "http://schema.org/Review",
    itemProp: "review",
    itemScope: true
  }, ___EmotionJSX(Box, {
    mr: 3
  }, ___EmotionJSX(Flex, {
    color: "white",
    justifyContent: "center",
    alignItems: "center",
    size: "65px",
    fontSize: "2rem",
    borderRadius: "50%",
    bg: avatarColours[author.toLowerCase().substring(0, 1)] || avatarColours.h,
    itemProp: "author",
    itemType: "https://schema.org/Person",
    itemScope: true
  }, author.toUpperCase(), ___EmotionJSX(MetaTags, {
    tags: [{
      itemProp: "name",
      content: author.toUpperCase()
    }]
  }))), ___EmotionJSX(Box, {
    flexGrow: 1
  }, ___EmotionJSX(Flex, {
    justifyContent: "space-between",
    itemProp: "reviewRating",
    itemType: "http://schema.org/Rating",
    itemScope: true
  }, ___EmotionJSX(StarRating, {
    rating: rating,
    backgroundColour: backgroundColor
  }), ___EmotionJSX(Text, {
    color: "typography.subText"
  }, date, ___EmotionJSX(MetaTags, {
    tags: [{
      itemProp: "datePublished",
      content: dateUtils.format(date, "yyyy-MM-dd")
    }]
  })), ___EmotionJSX(MetaTags, {
    tags: [{
      itemProp: "worstRating",
      content: "1"
    }, {
      itemProp: "ratingValue",
      content: "".concat(rating)
    }, {
      itemProp: "bestRating",
      content: "5"
    }]
  })), comment && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Text, {
    itemProp: "description"
  }, comment), helpfulReviews.totalCount > 0 && ___EmotionJSX(Text, {
    fontWeight: "semibold"
  }, helpfulReviews.positiveCount == 1 && helpfulReviews.totalCount == 1 ? "1 customer found this helpful" : "".concat(helpfulReviews.positiveCount, " out of ").concat(helpfulReviews.totalCount, " customers found this helpful")), !customerOwnsReview && ___EmotionJSX(Flex, {
    mb: 0
  }, ___EmotionJSX(Span, {
    fontWeight: "semibold",
    mr: "5px"
  }, "Was this helpful?"), !helpfulReviews.customerHelpfulFeedback ? ___EmotionJSX(Span, null, ___EmotionJSX(TextButton, {
    onClick: function onClick() {
      return handleUpdateHelpfulReview(1);
    }
  }, "Yes"), " | ", ___EmotionJSX(TextButton, {
    onClick: function onClick() {
      return handleUpdateHelpfulReview(-1);
    }
  }, "No")) : ___EmotionJSX(Span, null, helpfulReviews.customerHelpfulFeedback < 0 ? "No" : "Yes", " | ", ___EmotionJSX(TextButton, {
    onClick: function onClick() {
      return handleUpdateHelpfulReview(0);
    }
  }, "Cancel")), loading && ___EmotionJSX(LoadingSpinner, {
    width: "20px",
    height: "20px",
    ringSize: "2px",
    ml: "5px"
  })), comment && requiresAuth && ___EmotionJSX(Text, {
    m: "0"
  }, "You must ", ___EmotionJSX(Link, {
    href: "/login"
  }, "login"), " to rate this review."))));
};